import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { setPageMeta } from "@/lib/api";
import { Splatter } from "@/components/Splatter";
import QuoteForm from "@/components/QuoteForm";

export default function Quote() {
  const [params] = useSearchParams();
  const category = params.get("category") || "demande-de-devis";
  const subject = params.get("subject") || "";
  useEffect(() => { setPageMeta("Demande de devis — Tenay Ain-Pression", "Demandez un devis gratuit pour votre création 3D personnalisée ou votre projet sur mesure."); }, []);
  return (
    <div>
      <section className="relative overflow-hidden border-b border-white/10">
        <Splatter />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-14">
          <h1 className="font-heading text-4xl sm:text-5xl font-black">Demande de devis</h1>
          <p className="mt-3 text-gray-400 max-w-2xl">Décrivez votre projet et joignez vos fichiers. Nous vous répondons avec un devis personnalisé.</p>
        </div>
      </section>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
        <QuoteForm defaultCategory={category} defaultSubject={subject} />
      </div>
    </div>
  );
}
